import React from 'react';
import { View, type ScrollViewProps } from 'react-native';
import { styled } from 'nativewind';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import useKeyboard from '~/hooks/useKeyboard';

const StyledKeyboardAvoidingScrollView = styled(KeyboardAwareScrollView);

interface KeyboardScreenContainerProps extends ScrollViewProps {
  children: React.ReactNode;
  className?: string;
  footer?: React.ReactNode;
}

const contentContainerStyle = {
  flexGrow: 1,
};

const KeyboardScreenContainer: React.FC<KeyboardScreenContainerProps> = ({
  children,
  className,
  footer,
  ...rest
}) => {
  const { height } = useKeyboard();

  return (
    <>
      <StyledKeyboardAvoidingScrollView
        bounces={false}
        keyboardShouldPersistTaps="handled"
        keyboardDismissMode="none"
        className={`flex-1 bg-light-100 container mx-auto max-w-5xl ${className}`}
        scrollEventThrottle={16}
        contentContainerStyle={contentContainerStyle}
        {...rest}
      >
        {children}
      </StyledKeyboardAvoidingScrollView>
      <View
        style={{
          marginBottom: height,
          marginTop: -height,
        }}
      >
        {footer}
      </View>
    </>
  );
};

export default KeyboardScreenContainer;
